import React, { useEffect, useState } from "react";
import Select from "react-select";
import { DatePicker } from "antd";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { Tabs } from "antd";

import { BASE_CRM_URL } from "../../../../components/config/config";
import Swal from "sweetalert2";
import dayjs from "dayjs";

const EditProposalForm = () => {
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  const userId = userDetails?.staffid;

  const navigate = useNavigate();
  const { id } = useParams();

  // console.log("Proposal Id:", id);

  const [items, setItems] = useState([]);
  const [discount, setDiscount] = useState(0);
  const [adjustment, setAdjustment] = useState(0);
  const [quantityOption, setQuantityOption] = useState("Qty");

  //Add proposal  integration code

  const { state } = useLocation();

  // console.log(state, "state................................");
  // console.log("Lead ID:", state?.leadId);
  // console.log("Customer ID:", state?.customerId);

  const customermainid = state?.customerId;
  const leadmainid = state?.leadId;

  const [formData, setFormData] = useState({
    subject: "",
    content: "",
    proposal_to: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    country: null,
    rel_id: null,
    rel_type: "",
    project_id: null,
    adjustment: 0,
    currency: null,
  });

  const [currencies, setCurrencies] = useState([]);
  const [currencyLoading, setCurrencyLoading] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState(null);

  const [assignedOptions, setAssignedOptions] = useState([]);
  const [assignedLoading, setAssignedLoading] = useState(false);
  const [selectedAssigned, setSelectedAssigned] = useState(null);

  const [countries, setCountries] = useState([]);
  const [countryLoading, setCountryLoading] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);

  const [discountOptions, setDiscountOptions] = useState([]);
  const [discountLoading, setDiscountLoading] = useState(false);
  const [selectedDiscountType, setSelectedDiscountType] = useState(null);

  const [relatedOptions, setRelatedOptions] = useState([]);
  const [relatedLoading, setRelatedLoading] = useState(false);
  const [selectedRelated, setSelectedRelated] = useState(null);

  const [selectedLead, setSelectedLead] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const [selectedRelatedName, setSelectedRelatedName] = useState("");

  const [leadOptions, setLeadOptions] = useState([]);
  const [customerOptions, setCustomerOptions] = useState([]);

  const [itemOptions, setItemOptions] = useState([]);
  const [itemLoading, setItemLoading] = useState(false);

  const [taxOptions, setTaxOptions] = useState([]);
  const [taxLoading, setTaxLoading] = useState(false);

  const [startDate, setStartDate] = useState(dayjs());
  const [endDate, setEndDate] = useState(dayjs().add(15, "day"));

  const [projectOptions, setProjectOptions] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [projectLoading, setProjectLoading] = useState(false);

  const [isPrefilled, setIsPrefilled] = useState(false);

  const [saving, setSaving] = useState(false);

  const [openDiscountDropdown, setOpenDiscountDropdown] = useState(false);
  const [isReadOnly, setIsReadOnly] = useState(false);

  const [proposalData, setProposalData] = useState(null);

  useEffect(() => {
    if (!state || relatedOptions.length === 0) return;

    if (state.type === "lead") {
      const lead = state.record;

      // Select "Lead" in Related dropdown
      const related = relatedOptions.find(
        (item) => item.label.toLowerCase() === "lead"
      );

      setSelectedRelated(related);
      setSelectedRelatedName("Lead");

      setSelectedLead({
        value: lead.id,
        label: lead.name,
      });

      if (state.type === "lead") {
        fillLeadDetails(state.record);
      }

      setFormData((prev) => ({
        ...prev,
        proposal_to: lead.name || "",
        email: lead.email || "",
        phone: lead.phonenumber || "",
        address: lead.address || "",
        city: lead.city || "",
        state: lead.state || "",
        zip: lead.zip || "",
        country: lead.country || null,
        rel_id: lead.id,
        rel_type: "lead",
      }));
      setIsPrefilled(true);
      setSelectedCountry(
        countries.find((c) => c.value === lead.country) || null
      );
    }

    // console.log("State.......:", state);
    // console.log("State Type,,,,,,,,,:", state?.type);

    if (state.type === "customer") {
      const customer = state.record;

      // Select "Customer" in Related dropdown
      const related = relatedOptions.find(
        (item) => item.label.toLowerCase() === "customer"
      );

      setSelectedRelated(related);
      setSelectedRelatedName("Customer");

      setSelectedCustomer({
        value: customer.customerId,
        label: customer.company,
      });
      if (state.type === "customer") {
        fillCustomerDetails(state.record);
        getProjects(state.record.customerId);
      }

      setFormData((prev) => ({
        ...prev,
        proposal_to: customer.company || "",
        email: customer.email || "",
        phone: customer.phonenumber || "",
        address: customer.address || "",
        city: customer.city || "",
        state: customer.state || "",
        zip: customer.zip || "",
        country: customer.country || null,
        rel_id: customer.customerId,
        rel_type: "customer",
        currency: customer.default_currency,
      }));
      setIsPrefilled(true);
      setSelectedCurrency(
        currencies.find(
          (item) => Number(item.value) === Number(customer.default_currency)
        ) || null
      );
      setSelectedCountry(
        countries.find((c) => c.value === customer.country) || null
      );

      getProjects(customer.customerId);
    }
  }, [state, relatedOptions, countries]);

  const fillLeadDetails = (lead) => {
    // console.log("leads Data.........:", lead);
    setFormData((prev) => ({
      ...prev,
      proposal_to: lead.name || "",
      email: lead.email || "",
      phone: lead.phonenumber || "",
      address: lead.address || "",
      city: lead.city || "",
      state: lead.state || "",
      zip: lead.zip || "",
      country: lead.country || null,
      rel_id: lead.id,
      rel_type: "lead",
    }));
    setIsPrefilled(true);
    setIsReadOnly(true);

    setSelectedCountry(countries.find((c) => c.value === lead.country) || null);

    setSelectedLead({
      value: lead.id,
      label: lead.name,
    });
  };

  const fillCustomerDetails = (customer) => {
    // console.log("Customer Data.........:", customer);
    setFormData((prev) => ({
      ...prev,
      proposal_to: customer.company || "",
      email: customer.email || "",
      phone: customer.phonenumber || "",
      address: customer.address || "",
      city: customer.city || "",
      state: customer.state || "",
      zip: customer.zip || "",
      country: customer.country || null,
      rel_id: customer.customerId,
      rel_type: "customer",
      currency: customer.default_currency,
    }));
    setIsPrefilled(true);
    setIsReadOnly(true);

    setSelectedCurrency(
      currencies.find(
        (item) => Number(item.value) === Number(customer.default_currency)
      ) || null
    );

    setSelectedCountry(
      countries.find((c) => c.value === customer.country) || null
    );

    setSelectedCustomer({
      value: customer.customerId,
      label: customer.company,
    });
  };

  useEffect(() => {
    if (!state) {
      setIsReadOnly(false);
    }
  }, [state]);

  const prefillStyle = isPrefilled
    ? {
        backgroundColor: "#EAF4FF",
        border: "1px solid #8CC4FF",
      }
    : {};
  const prefillSelectStyles = isPrefilled
    ? {
        control: (provided) => ({
          ...provided,
          backgroundColor: "#EAF4FF",
          borderColor: "#8CC4FF",
          boxShadow: "none",
          "&:hover": {
            borderColor: "#8CC4FF",
          },
        }),
      }
    : {};

  // ---------------------------------

  // const [selectedTaxes, setSelectedTaxes] = useState([]);
  // const [selectedTaxes, setSelectedTaxes] = useState([]);
  const [discountType, setDiscountType] = useState("before"); // before | after

  console.log(taxOptions, taxLoading, countryLoading, "..................");

  const getRelatedTypes = async () => {
    try {
      setRelatedLoading(true);

      const response = await fetch(`${BASE_CRM_URL}RelatedToType`);
      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.Id,
          label: item.RelatedToType,
          name: item.RelatedToType,
        }));

        setRelatedOptions(options);

        // Optional: Set first option as default
        if (options.length > 0) {
          setSelectedRelated(options[0].value);
        }
      }
    } catch (error) {
      console.error("Error fetching related types:", error);
    } finally {
      setRelatedLoading(false);
    }
  };

  const getCustomers = async () => {
    try {
      // setRelatedLoading(true);

      const response = await fetch(`${BASE_CRM_URL}customers/GetCustomers`);
      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.customerId,
          label: item.company,
        }));

        setCustomerOptions(options);

        // if (options.length > 0) {
        //   setSelectedRelated(options[0].value);
        // }
      }
    } catch (error) {
      console.error("Error fetching related types:", error);
    } finally {
      setRelatedLoading(false);
    }
  };

  const getLeads = async () => {
    try {
      // setRelatedLoading(true);

      const response = await fetch(`${BASE_CRM_URL}leads/GetLeads`);
      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        console.log(options, "leadoptions");

        setLeadOptions(options);

        // // Optional: Set first option as default
        // if (options.length > 0) {
        //   setSelectedRelated(options[0].value);
        // }
      }
    } catch (error) {
      console.error("Error fetching related types:", error);
    } finally {
      setRelatedLoading(false);
    }
  };

  const getCurrencies = async () => {
    try {
      setCurrencyLoading(true);

      const response = await fetch(`${BASE_CRM_URL}expenses/GetCurrencies`);
      const data = await response.json(); // <-- Parse JSON

      // console.log(data);

      if (data.Status) {
        const options = data.Data.map((item) => ({
          value: item.id,
          label: `${item.symbol} ${item.name}`,
        }));

        // console.log(options);

        setCurrencies(options);

        if (options.length > 0) {
          setSelectedCurrency(options[0].value);
        }
      }
    } catch (error) {
      console.error("Error fetching currencies:", error);
    } finally {
      setCurrencyLoading(false);
    }
  };

  const getAssignedStaff = async () => {
    try {
      setAssignedLoading(true);

      const response = await fetch(`${BASE_CRM_URL}staff/GetStaffDropdown`);
      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.staffid,
          label: `${item.firstname} ${item.lastname}`,
        }));

        setAssignedOptions(options);

        // Set first staff as default (optional)
        if (options.length > 0) {
          setSelectedAssigned(options[0].value);
        }
      }
    } catch (error) {
      console.error("Error fetching staff:", error);
    } finally {
      setAssignedLoading(false);
    }
  };

  const getCountries = async () => {
    try {
      setCountryLoading(true);

      const response = await fetch(`${BASE_CRM_URL}GetCountries`);
      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.country_id,
          label: item.short_name,
        }));

        setCountries(options);

        // Optional: Set India as default if available
        const india = options.find((item) => item.label === "India");

        if (india) {
          setSelectedCountry(india.value);
        } else if (options.length > 0) {
          setSelectedCountry(options[0].value);
        }
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
    } finally {
      setCountryLoading(false);
    }
  };

  const getDiscountTypes = async () => {
    try {
      setDiscountLoading(true);

      const response = await fetch(`${BASE_CRM_URL}GetDescountTypes`);
      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.Id,
          label: item.TaxType,
        }));

        setDiscountOptions(options);

        // Optional: Set first option as default
        if (options.length > 0) {
          setSelectedDiscountType(options[0].value);
        }
      }
    } catch (error) {
      console.error("Error fetching discount types:", error);
    } finally {
      setDiscountLoading(false);
    }
  };

  const getProducts = async () => {
    try {
      setItemLoading(true);

      const response = await fetch(`${BASE_CRM_URL}products/GetProducts`);
      const data = await response.json();

      if (data.Status) {
        const products = data.Data.map((item) => ({
          id: item.id,
          item: item.description,
          description: item.long_description || item.description,
          hsn: "",
          qty: 1,
          rate: parseFloat(item.rate),
          amount: parseFloat(item.rate),
          unit: item.unit,

          tax: item.tax,
          tax2: item.tax2,

          tax_id: item.tax_id,
          tax2_id: item.tax2_id,

          tax_name: item.tax_name,
          tax2_name: item.tax2_name,
        }));

        setItemOptions(products);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setItemLoading(false);
    }
  };

  const getTaxes = async () => {
    try {
      setTaxLoading(true);

      const response = await fetch(`${BASE_CRM_URL}GetTaxes`);
      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.Id,
          label: item.Name,
          taxrate: Number(item.taxrate),
        }));

        setTaxOptions(options);
      }
    } catch (error) {
      console.error("Error fetching taxes:", error);
    } finally {
      setTaxLoading(false);
    }
  };
  const getProjects = async (customerId) => {
    try {
      setProjectLoading(true);

      const response = await fetch(
        `${BASE_CRM_URL}project/GetProjectsByCusId?CusID=${customerId}`
      );

      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        setProjectOptions(options);
      } else {
        setProjectOptions([]);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
      setProjectOptions([]);
    } finally {
      setProjectLoading(false);
    }
  };

  const getLeadDetails = async (leadId) => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}leads/GetLeadById?LeadId=${leadId}`
      );

      const data = await response.json();

      if (data.Status) {
        const lead = data.ResultData;

        setFormData((prev) => ({
          ...prev,
          proposal_to: lead.name || "",
          email: lead.email || "",
          phone: lead.phonenumber || "",
          address: lead.address || "",
          city: lead.city || "",
          state: lead.state || "",
          zip: lead.zip || "",
          country: lead.country || null,
          rel_id: lead.id,
          rel_type: "lead",
        }));

        setSelectedCountry(
          countries.find((c) => c.value === lead.country) || null
        );
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getCustomerDetails = async (customerId) => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}customers/GetCustomerDetails?CusId=${customerId}`
      );

      const data = await response.json();

      if (data.Status && data.ResultData?.length > 0) {
        fillCustomerDetails(data.ResultData[0]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (
      !proposalData ||
      !relatedOptions.length ||
      !countries.length ||
      !currencies.length ||
      !assignedOptions.length ||
      !discountOptions.length ||
      !leadOptions.length ||
      !customerOptions.length ||
      !itemOptions.length ||
      !taxOptions.length
    )
      return;

    prefillProposal(proposalData);
  }, [
    proposalData,
    relatedOptions,
    countries,
    currencies,
    assignedOptions,
    discountOptions,
    customerOptions,
    leadOptions,
    itemOptions,
    taxOptions,
  ]);

  const prefillProposal = (data) => {
    const proposal = data.Proposal;

    setFormData({
      subject: proposal.subject || "",
      content: proposal.content || "",
      proposal_to: proposal.proposal_to || "",
      email: proposal.email || "",
      phone: proposal.phone || "",
      address: proposal.address || "",
      city: proposal.city || "",
      state: proposal.state || "",
      zip: proposal.zip || "",
      country: proposal.country,
      rel_id: proposal.rel_id,
      rel_type: proposal.rel_type,
      project_id: proposal.project_id,
      adjustment: Number(proposal.adjustment),
      currency: proposal.currency,
    });

    setDiscount(Number(proposal.discount_percent));

    setAdjustment(Number(proposal.adjustment));

    setStartDate(dayjs(proposal.datecreated));

    setEndDate(dayjs(proposal.open_till));

    setSelectedRelated(
      relatedOptions.find(
        (x) => x.label.toLowerCase() === proposal.rel_type.toLowerCase()
      )
    );

    setSelectedRelatedName(
      proposal.rel_type === "customer" ? "Customer" : "Lead"
    );

    if (proposal.rel_type === "lead") {
      const lead = leadOptions.find(
        (x) => Number(x.value) === Number(proposal.rel_id)
      );

      console.log("Lead Found :", lead);

      setSelectedLead(lead || null);
    }

    setSelectedCountry(
      countries.find((x) => Number(x.value) === Number(proposal.country))
    );

    setSelectedCurrency(
      currencies.find((x) => Number(x.value) === Number(proposal.currency))
    );

    setSelectedAssigned(
      assignedOptions.find((x) => Number(x.value) === Number(proposal.assigned))
    );

    const discountObj = discountOptions.find(
      (x) => Number(x.value) === Number(proposal.discount_type)
    );

    setSelectedDiscountType(discountObj);

    setDiscountType(proposal.discount_type == 1 ? "before" : "after");

    console.log("Proposal Lead ID:", proposal.rel_id);
    console.log("Lead Options:", leadOptions);

    const selectedLeadOption = leadOptions.find(
      (x) => Number(x.value) === Number(proposal.rel_id)
    );

    console.log("Selected Lead:", selectedLeadOption);

    // if(proposal.rel_type==="lead"){

    //     setSelectedLead(
    //         leadOptions.find(
    //             x=>Number(x.value)===Number(proposal.rel_id)
    //         )
    //     );

    // }

    if (proposal.rel_type === "customer") {
      const customer = customerOptions.find(
        (x) => Number(x.value) === Number(proposal.rel_id)
      );

      setSelectedCustomer(customer);

      getProjects(proposal.rel_id);
    }

    fillProposalItems(data);
  };

  const getProposalById = async (proposalId) => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}proposal/GetProposal/${proposalId}`
      );

      const data = await response.json();

      setProposalData(data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const loadData = async () => {
      await getCurrencies();
      await getAssignedStaff();
      await getCountries();
      await getDiscountTypes();
      await getRelatedTypes();
      await getProducts();
      await getTaxes();
      await getCustomers();
      await getLeads();

      if (id) {
        await getProposalById(id);
      }
    };

    loadData();
  }, [id]);

  useEffect(() => {
    if (!proposalData || !projectOptions.length) return;

    const project = projectOptions.find(
      (x) => Number(x.value) === Number(proposalData.project_id)
    );

    setSelectedProject(project || null);
  }, [proposalData, projectOptions]);

  const fillProposalItems = (data) => {
    const items = data.ItemDetails;
    const related = data.RelatedItems;

    const mapped = items.map((item, index) => {
      const relatedItem = related[index];

      const product = itemOptions.find(
        (p) => Number(p.id) === Number(relatedItem.item_id)
      );

      const selectedTaxes = taxOptions.filter(
        (tax) =>
          Number(tax.value) === Number(product?.tax) ||
          Number(tax.value) === Number(product?.tax2)
      );

      return {
        id: item.id,

        productId: relatedItem.item_id,

        item: product?.item,

        description: item.long_description,

        qty: Number(item.qty),

        rate: Number(item.rate),

        unit: item.unit,

        amount: Number(item.qty) * Number(item.rate),

        selectedTaxes,

        taxes: selectedTaxes,

        isSaved: true,
      };
    });

    setItems(mapped);
  };

  const addItem = (item) => {
    const newItem = {
      id: Date.now(),
      ...item,
      selectedTaxes: item.selectedTaxes || [],
      taxes: [],
      isSaved: false,
    };

    setItems((prev) => [...prev, newItem]);
  };
  const deleteItem = (id) => {
    setItems(items.filter((item) => item.id !== id));
  };

  const saveItem = (id) => {
    setItems((prev) =>
      prev.map((item) => {
        if (item.id !== id) return item;

        return {
          ...item,
          taxes: item.selectedTaxes,
          isSaved: true,
        };
      })
    );
  };

  const editItem = (id) => {
    setItems((prev) =>
      prev.map((item) =>
        item.id === id
          ? {
              ...item,
              isSaved: false,
            }
          : item
      )
    );
  };
  // const updateItem = (id, field, value) => {
  //   setItems((prev) =>
  //     prev.map((item) =>
  //       item.id === id
  //         ? {
  //             ...item,
  //             [field]: value,
  //           }
  //         : item
  //     )
  //   );
  // };

  const calculateSubtotal = () => {
    return items.reduce((sum, item) => {
      const qty =
        quantityOption === "Hours"
          ? Number(item.hours || 0)
          : Number(item.qty || 0);

      return sum + qty * Number(item.rate || 0);
    }, 0);
  };
  const calculateDiscount = (amount) => {
    return (amount * discount) / 100;
  };
  const subtotal = calculateSubtotal();

  const discountAmount = calculateDiscount(subtotal);

  const calculateTaxes = () => {
    const taxSummary = {};

    items.forEach((item) => {
      const qty =
        quantityOption === "Hours"
          ? Number(item.hours || 0)
          : Number(item.qty || 0);

      const amount = qty * Number(item.rate || 0);

      (item.taxes || []).forEach((tax) => {
        const taxAmount = (amount * Number(tax.taxrate || 0)) / 100;

        if (!taxSummary[tax.label]) {
          taxSummary[tax.label] = {
            name: tax.label,
            amount: 0,
          };
        }

        taxSummary[tax.label].amount += taxAmount;
      });
    });

    // Return ARRAY instead of OBJECT
    return Object.values(taxSummary);
  };

  const totalTax = calculateTaxes().reduce(
    (sum, tax) => sum + tax.amount,

    0
  );

  const calculateTotal = () => {
    let total;

    if (discountType === "before") {
      total = subtotal - discountAmount + totalTax + adjustment;
    } else {
      total = subtotal + totalTax - discountAmount + adjustment;
    }

    return total;
  };

  const updateProposal = async (e) => {
    e.preventDefault();
    try {
      setSaving(true);

      const payload = {
        id: proposalData.Proposal.id,
        subject: formData.subject,
        content: formData.content,
        addedfrom: userId,
        total: calculateTotal(),
        subtotal: calculateSubtotal(),
        total_tax: calculateTaxes().reduce((sum, tax) => sum + tax.amount, 0),
        adjustment: formData.adjustment,
        rel_id:
          selectedRelatedName === "Customer"
            ? selectedCustomer?.value
            : selectedLead?.value,
        rel_type: selectedRelatedName.toLowerCase(),
        project_id: selectedProject?.value || 0, // <-- Project
        assigned: userId,
        proposal_to: formData.proposal_to,
        country: selectedCountry?.value,
        zip: formData.zip,
        state: formData.state,
        city: formData.city,
        address: formData.address,
        email: formData.email,
        phone: formData.phone,
        status: 1,
        discount_percent: discount,
        discount_total: calculateDiscount(calculateSubtotal()),
        discount_type: selectedDiscountType?.value || 0,
        currency: selectedCurrency?.value || 1,
        hash: "",
        open_till: endDate ? endDate.format("YYYY-MM-DD") : null,
        items: items.map((item) => ({
          item_id: item.productId,

          description: item.description,

          qty: Number(item.qty),

          rate: Number(item.rate),

          tax: item.taxId,

          tax_name: item.taxName,

          tax_rate: item.taxRate,

          unit: item.unit,
        })),
      };

      // console.log(payload, "payload................");

      const response = await fetch(`${BASE_CRM_URL}proposal/updateProposal`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message || "Proposal added successfully.",
          confirmButtonColor: "#3085d6",
        }).then(() => {
          if (selectedRelatedName === "Lead") {
            navigate(`/crm/viewleads/${leadmainid}`);
            return;
          }

          if (selectedRelatedName === "Customer") {
            navigate(`/crm/customerinfo/${customermainid}`);
            return;
          }

          navigate("/crm/proposals");
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: data.Message || "Unable to add proposal.",
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setSaving(false);
    }
  };

  const tabItems = [
    {
      key: "1",
      label: (
        <>
          <i className="bi bi-person-lines-fill me-2"></i>
          Customer
        </>
      ),
      children: (
        <>
          <div className="row">
            <div className="col-md-6 col-xl-6 mb-3 ">
              <label>Subject</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Subject"
                value={formData.subject}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    subject: e.target.value,
                  }))
                }
              />
            </div>

            <div className="col-md-4 col-xl-3 mb-3">
              <label>Related (Customer/Lead)</label>
              <Select
                options={relatedOptions}
                value={selectedRelated}
                styles={prefillSelectStyles}
                style={prefillStyle}
                loading={relatedLoading}
                placeholder="Select Related"
                onChange={(value) => {
                  console.log("Selected Value:", value);
                  setSelectedRelated(value);
                  setSelectedRelatedName(value.name);

                  setSelectedLead(null);
                  setSelectedCustomer(null);
                }}
                isDisabled={isReadOnly}
              />
            </div>

            {selectedRelatedName === "Lead" && (
              <div className="col-md-4 col-xl-3 mb-3">
                <label>Lead</label>
                <Select
                  options={leadOptions}
                  value={selectedLead}
                  styles={prefillSelectStyles}
                  style={prefillStyle}
                  isDisabled={isReadOnly}
                  placeholder="Select Lead"
                  onChange={async (option) => {
                    setSelectedLead(option);

                    await getLeadDetails(option.value);
                  }}
                />
              </div>
            )}
            {selectedRelatedName === "Customer" && (
              <div className="col-md-4 col-xl-3 mb-3">
                <label>Customer</label>

                <Select
                  options={customerOptions}
                  value={selectedCustomer}
                  styles={prefillSelectStyles}
                  style={prefillStyle}
                  isDisabled={isReadOnly}
                  placeholder="Select Customer"
                  onChange={async (option) => {
                    setSelectedCustomer(option);

                    await getCustomerDetails(option.value);

                    getProjects(option.value);
                  }}
                />
              </div>
            )}

            {selectedCustomer && (
              <div className="col-md-4 col-xl-3 mb-3">
                <label>Project</label>

                <Select
                  options={projectOptions}
                  isDisabled={isReadOnly}
                  style={prefillStyle}
                  styles={prefillSelectStyles}
                  value={selectedProject}
                  isLoading={projectLoading}
                  placeholder="Select Project"
                  onChange={(option) => setSelectedProject(option)}
                />
              </div>
            )}

            <div className="col-md-4 col-xl-3  mb-3">
              <label>Email</label>
              <input
                type="email"
                className="form-control"
                style={prefillStyle}
                disabled={isReadOnly}
                placeholder="Enter Email"
                value={formData.email}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    email: e.target.value,
                  }))
                }
              />
            </div>
            <div className="col-md-4 col-xl-3  mb-3">
              <label>Phone</label>
              <input
                type="text"
                className="form-control"
                style={prefillStyle}
                disabled={isReadOnly}
                placeholder="Enter PhoneNumber"
                value={formData.phone}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    phone: e.target.value,
                  }))
                }
              />
            </div>

            <div className="col-md-4 col-xl-3 mb-3">
              <label>Date</label>
              <DatePicker
                value={startDate}
                format="DD-MM-YYYY"
                style={prefillStyle}
                className="w-100"
                onChange={(date) => {
                  setStartDate(date);

                  if (date) {
                    setEndDate(date.add(15, "day"));
                  } else {
                    setEndDate(null);
                  }
                }}
              />
            </div>

            <div className="col-md-4 col-xl-3 mb-3">
              <label>Open Till</label>
              <DatePicker
                value={endDate}
                format="DD-MM-YYYY"
                style={prefillStyle}
                className="w-100"
                onChange={(date) => setEndDate(date)}
              />
            </div>

            <div className="col-md-4 col-xl-3 d-none">
              <label>Assigned</label>
              <Select
                options={assignedOptions}
                value={selectedAssigned}
                loading={assignedLoading}
                placeholder="Select Staff"
                onChange={(value) => setSelectedAssigned(value)}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      key: "2",
      label: (
        <>
          <i className="bi bi-geo-alt me-2"></i>
          Address
        </>
      ),
      children: (
        <>
          <div className="row">
            <div className="col-4 mb-3">
              <label>To</label>
              <textarea
                className="form-control"
                placeholder="Eneter Name"
                style={prefillStyle}
                disabled={isReadOnly}
                value={formData.proposal_to}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    proposal_to: e.target.value,
                  }))
                }
              />
            </div>

            <div className="col-8 mb-3">
              <label>Address</label>
              <textarea
                className="form-control"
                placeholder="Enter Address"
                style={prefillStyle}
                disabled={isReadOnly}
                value={formData.address}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    address: e.target.value,
                  }))
                }
              />
            </div>

            <div className="col-3 mb-3">
              <label>City</label>
              <input
                type="text"
                className="form-control"
                placeholder="enter city"
                style={prefillStyle}
                disabled={isReadOnly}
                value={formData.city}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    city: e.target.value,
                  }))
                }
              />
            </div>
            <div className="col-3 mb-3">
              <label>State</label>
              <input
                type="text"
                className="form-control"
                placeholder="state"
                style={prefillStyle}
                disabled={isReadOnly}
                value={formData.state}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    state: e.target.value,
                  }))
                }
              />
            </div>
            <div className="col-3 mb-3">
              <label>Country</label>
              <Select
                options={countries}
                style={prefillStyle}
                styles={prefillSelectStyles}
                isDisabled={isReadOnly}
                value={selectedCountry}
                onChange={(option) => {
                  setSelectedCountry(option);

                  setFormData((prev) => ({
                    ...prev,
                    country: option?.value || null,
                  }));
                }}
              />
            </div>
            <div className="col-3 mb-3">
              <label>Zip Code</label>
              <input
                type="text"
                style={prefillStyle}
                placeholder="enter zip"
                disabled={isReadOnly}
                className="form-control"
                value={formData.zip}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    zip: e.target.value,
                  }))
                }
              />
            </div>
          </div>
        </>
      ),
    },

    {
      key: "3",
      label: (
        <>
          <i className="bi bi-cart3 me-2"></i>
          Items & Totals
        </>
      ),
      children: (
        <>
          {" "}
          <div className="row">
            <div className="col-4 mb-3">
              <Select
                options={itemOptions.map((option) => ({
                  value: option.id,
                  label: option.item,
                  ...option, // include all properties
                }))}
                isLoading={itemLoading}
                placeholder="Select Item"
                onChange={(selectedOption) => {
                  if (!selectedOption) return;

                  // console.log("Selected Product:", selectedOption);
                  // console.log("Product Tax:", selectedOption.tax);
                  // console.log("Tax Options:", taxOptions);

                  addItem({
                    item: selectedOption.item,
                    description: selectedOption.description,
                    hsn: selectedOption.hsn,
                    qty: selectedOption.qty,
                    rate: selectedOption.rate,
                    amount: selectedOption.amount,
                    unit: selectedOption.unit,
                    productId: selectedOption.id,
                    tax: selectedOption.tax,

                    selectedTaxes: taxOptions.filter(
                      (tax) =>
                        Number(tax.value) === Number(selectedOption.tax) ||
                        Number(tax.value) === Number(selectedOption.tax2)
                    ),
                  });
                }}
              />
            </div>

            {/* Radio buttons to switch quantity display */}
            <div className="d-flex justify-content-end col-4 d-none">
              <fieldset>
                <label>
                  <b>Show quantity as:</b>
                </label>
                <div className="form-check ms-2 form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="quantityOptions"
                    id="qty"
                    value="Qty"
                    checked={quantityOption === "Qty"}
                    onChange={() => setQuantityOption("Qty")}
                  />
                  <label className="form-check-label" htmlFor="qty">
                    Qty
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="quantityOptions"
                    id="hours"
                    value="Hours"
                    checked={quantityOption === "Hours"}
                    onChange={() => setQuantityOption("Hours")}
                  />
                  <label className="form-check-label" htmlFor="hours">
                    Hours
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="quantityOptions"
                    id="qtyHours"
                    value="Qty/Hours"
                    checked={quantityOption === "Qty/Hours"}
                    onChange={() => setQuantityOption("Qty/Hours")}
                  />
                  <label className="form-check-label" htmlFor="qtyHours">
                    Qty/Hours
                  </label>
                </div>
              </fieldset>
            </div>

            <div className="d-flex justify-content-end gap-3 col-8">
              {/* <div className="col-3">
                <Select
                  isMulti
                  closeMenuOnSelect={false}
                  options={taxOptions}
                  value={selectedTaxes}
                  placeholder="Select Taxes"
                  onChange={(value) => {
                    setSelectedTaxes(value || []);
                  }}
                />
              </div> */}

              <div className="col-3">
                <Select
                  options={currencies}
                  value={selectedCurrency}
                  loading={currencyLoading}
                  isDisabled={isReadOnly}
                  styles={prefillSelectStyles}
                  placeholder="Select Currency"
                  onChange={(option) => {
                    setSelectedCurrency(option);

                    setFormData((prev) => ({
                      ...prev,
                      currency: option?.value || null,
                    }));
                  }}
                />
              </div>

              {discount > 0 && (
                <div className="col-3">
                  <Select
                    options={discountOptions}
                    value={selectedDiscountType}
                    isLoading={discountLoading}
                    placeholder="Select Discount"
                    menuIsOpen={openDiscountDropdown}
                    onMenuClose={() => setOpenDiscountDropdown(false)}
                    onChange={(option) => {
                      setSelectedDiscountType(option);

                      // Convert API label to your internal value
                      setDiscountType(option.value === 1 ? "before" : "after");

                      setOpenDiscountDropdown(false);
                    }}
                  />
                </div>
              )}
            </div>

            {/* Table to display items */}
            <div className="table-responsive mt-2">
              <table className="table table-bordered">
                <thead className="table-light">
                  <tr>
                    <th>Item</th>
                    <th>Description</th>
                    <th>HSN</th>
                    <th>
                      {quantityOption === "Qty" && "Qty"}
                      {quantityOption === "Hours" && "Hours"}
                      {quantityOption === "Qty/Hours" && "Qty/Hours"}
                    </th>
                    <th>Rate</th>
                    <th>Tax</th>
                    <th>Total</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {items.length === 0 ? (
                    <tr>
                      <td colSpan="8" className="text-center">
                        No data available
                      </td>
                    </tr>
                  ) : (
                    items.map((item) => {
                      const quantity =
                        quantityOption === "Hours" ? item.hours : item.qty;
                      const total = (quantity || 0) * (item.rate || 0);
                      // const taxAmount = (total * parseFloat(item.tax)) / 100;
                      const taxAmount =
                        (total * Number(item.taxRate || 0)) / 100;

                      const rowTotal = total + taxAmount;

                      return (
                        <tr key={item.id}>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              value={item.item}
                              readOnly
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              value={item.description}
                              readOnly
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              disabled={item.isSaved}
                              className="form-control"
                              value={item.hsn}
                              onChange={(e) =>
                                setItems(
                                  items.map((i) =>
                                    i.id === item.id
                                      ? { ...i, hsn: e.target.value }
                                      : i
                                  )
                                )
                              }
                            />
                          </td>
                          <td>
                            {quantityOption === "Qty" ||
                            quantityOption === "Qty/Hours" ? (
                              <input
                                type="number"
                                disabled={item.isSaved}
                                className="form-control"
                                value={item.qty}
                                onChange={(e) =>
                                  setItems(
                                    items.map((i) =>
                                      i.id === item.id
                                        ? { ...i, qty: e.target.value }
                                        : i
                                    )
                                  )
                                }
                              />
                            ) : quantityOption === "Hours" ? (
                              <input
                                type="number"
                                className="form-control"
                                value={item.hours}
                                onChange={(e) =>
                                  setItems(
                                    items.map((i) =>
                                      i.id === item.id
                                        ? { ...i, hours: e.target.value }
                                        : i
                                    )
                                  )
                                }
                              />
                            ) : null}
                          </td>
                          <td>
                            <input
                              type="number"
                              disabled={item.isSaved}
                              className="form-control"
                              value={item.rate}
                              onChange={(e) =>
                                setItems(
                                  items.map((i) =>
                                    i.id === item.id
                                      ? { ...i, rate: e.target.value }
                                      : i
                                  )
                                )
                              }
                            />
                          </td>
                          <td>
                            {" "}
                            {item.isSaved ? (
                              <div className="d-flex flex-wrap gap-1">
                                {" "}
                                {item.taxes.map((tax) => (
                                  <span
                                    key={tax.value}
                                    className="badge bg-success"
                                  >
                                    {" "}
                                    {tax.label}{" "}
                                  </span>
                                ))}{" "}
                              </div>
                            ) : (
                              <Select
                                isMulti
                                closeMenuOnSelect={false}
                                options={taxOptions}
                                value={item.selectedTaxes}
                                placeholder="Select Tax"
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                styles={{
                                  valueContainer: (base) => ({
                                    ...base,
                                    flexWrap: "nowrap",
                                    overflowX: "auto",
                                    scrollbarWidth: "none",
                                  }),
                                  multiValue: (base) => ({
                                    ...base,
                                    minWidth: "fit-content",
                                  }),
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                }}
                                onChange={(value) => {
                                  setItems((prev) =>
                                    prev.map((row) =>
                                      row.id === item.id
                                        ? { ...row, selectedTaxes: value || [] }
                                        : row
                                    )
                                  );
                                }}
                              />
                            )}{" "}
                          </td>
                          <td>{rowTotal.toFixed(2)}</td> {/* Row total */}
                          <td>
                            {item.isSaved ? (
                              <button
                                type="button"
                                className="btn btn-warning btn-sm me-2"
                                onClick={() => editItem(item.id)}
                              >
                                <i className="fa-solid fa-pen"></i>
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn btn-success btn-sm me-2"
                                onClick={() => saveItem(item.id)}
                              >
                                <i className="fa-solid fa-check"></i>
                              </button>
                            )}

                            <button
                              type="button"
                              className="btn btn-danger btn-sm"
                              onClick={() => deleteItem(item.id)}
                            >
                              <i className="fa-solid fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>

            {/* Subtotal, Discount, IGST, and Total */}
            <div className="row mt-3">
              <div className="col-md-4"></div>
              <div className="col-md-4"></div>
              <div className="col-md-4">
                <div className="mb-1">
                  <div className="d-flex justify-content-between">
                    <span>Sub Total:</span>
                    <span>Rs.{calculateSubtotal().toFixed(2)}</span>
                  </div>
                  <hr />
                </div>

                <div className="mb-1">
                  <div className="d-flex justify-content-between">
                    <span>Discount:</span>
                    <div className="" style={{ width: "30%" }}>
                      <select
                        className="form-select"
                        value={discount}
                        onChange={(e) => {
                          setDiscount(Number(e.target.value));

                          if (Number(e.target.value) > 0) {
                            setOpenDiscountDropdown(true);
                          }
                        }}
                      >
                        <option value={0}>0%</option>
                        <option value={5}>5%</option>
                        <option value={10}>10%</option>
                        <option value={15}>15%</option>
                        <option value={20}>20%</option>
                      </select>
                    </div>
                    <span>
                      -Rs.
                      {calculateDiscount(calculateSubtotal()).toFixed(2)}
                    </span>
                  </div>
                  <hr />
                </div>

                {items.map((item, index) => {
                  const qty =
                    quantityOption === "Hours"
                      ? Number(item.hours || 0)
                      : Number(item.qty || 0);

                  const amount = qty * Number(item.rate || 0);

                  return (
                    <div key={item.id || index}>
                      {/* Product Name */}
                      <div className="fw-bold mb-1">{item.item}</div>

                      {(item.taxes || []).map((tax) => {
                        const taxAmount =
                          (amount * Number(tax.taxrate || 0)) / 100;

                        return (
                          <div
                            key={`${item.id}-${tax.value}`}
                            className="d-flex justify-content-between ms-3"
                          >
                            <span>{tax.label}</span>
                            <span>Rs. {taxAmount.toFixed(2)}</span>
                          </div>
                        );
                      })}

                      <hr />
                    </div>
                  );
                })}

                <div className="mb-1">
                  <div className="d-flex justify-content-between">
                    <span>Adjustment:</span>
                    <div style={{ width: "30%" }}>
                      <input
                        type="number"
                        className="form-control ms-1"
                        value={adjustment}
                        onChange={(e) =>
                          setAdjustment(parseFloat(e.target.value))
                        }
                      />
                    </div>
                    <span>Rs.{adjustment.toFixed(2)}</span>
                  </div>
                  <hr />
                </div>

                <div className="mb-1">
                  <div className="d-flex justify-content-end">
                    <strong>Total:</strong>
                    <strong> Rs.{calculateTotal().toFixed(2)}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ),
    },
  ];

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item">
              <div className="d-flex flex-column">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/crm/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Edit Proposal
                    </h4>
                  </ol>
                </nav>
                <p className="text-muted">Update Proposal Details</p>
              </div>
            </div>
            <div className="page-btn d-flex jusitfy-content-between">
              <Link
                to="/crm/proposals"
                className="btn btn-secondary btn-sm d-flex align-items-center"
              >
                <i className="ti ti-arrow-left fs-4 me-2"> </i>Back
              </Link>
            </div>
          </div>

          <div className="card">
            <div className="card-header ">
              <h4 className="text-primary">
                Edit Proposal - {formData.proposal_to}
              </h4>
            </div>
            <div className="card-body pt-0">
              <form onSubmit={updateProposal}>
                <Tabs
                  defaultActiveKey="1"
                  items={tabItems}
                  size="large"
                  tabBarGutter={30}
                  animated
                />

                <div className="d-flex justify-content-end mt-2">
                  <button type="submit" className="btn btn-info me-2">
                    Save & Send
                  </button>

                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={saving}
                  >
                    {saving ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Saving...
                      </>
                    ) : (
                      "Save"
                    )}
                  </button>
                </div>
              </form>
            </div>
            {/* <div className="card-footer d-flex justify-content-end">
              <button type="submit" className="btn btn-info me-2">
                Save & Send
              </button>
              <button type="submit" className="btn btn-primary">
                Save
              </button>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default EditProposalForm;
